// Pure helpers for detecting a newer dashboard deploy. Each deploy changes the
// hashed entry bundle name in index.html (e.g. /assets/index-AbC123.js).

const ENTRY_SRC_RE = /<script[^>]*\ssrc=["']([^"']*\/assets\/index-[^"']+\.js)["']/i

/** Returns the entry bundle src found in index.html text, or null. */
export function extractEntryScript(html: string): string | null {
  const match = ENTRY_SRC_RE.exec(html)
  return match ? match[1] : null
}

/** A new version exists only when both names are known and they differ. */
export function isNewVersion(current: string | null, latest: string | null): boolean {
  return !!current && !!latest && current !== latest
}

/** Entry script this tab loaded, read from the live document. */
export function getLoadedEntryScript(doc: Document = document): string | null {
  const el = doc.querySelector('script[type=module][src*="/assets/index-"]')
  return el?.getAttribute('src') ?? null
}

/** Fetches /index.html uncached; returns the entry script or null on any failure. */
export async function fetchLatestEntryScript(): Promise<string | null> {
  try {
    const res = await fetch('/index.html', { cache: 'no-store' })
    const html = await res.text()
    if (!res.ok) return null
    return extractEntryScript(html)
  } catch {
    return null
  }
}
